import { render, staticRenderFns } from "./EmployeeReferences.vue?vue&type=template&id=10136226&scoped=true"
import script from "./EmployeeReferences.vue?vue&type=script&lang=js"
export * from "./EmployeeReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10136226",
  null
  
)

export default component.exports